// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
#root {
  height: 100%;
}
.ant-layout {
  min-height: 100%;
}
.no-wrap {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
canvas {
  display: block;
}
body {
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.ant-layout.ant-layout-has-sider > .ant-layout, .ant-layout.ant-layout-has-sider > .ant-layout-content {
  overflow-x: auto !important;
}
.ant-spin-container {
  overflow: visible !important;
}
.ant-btn {
  transition: none;
}
.global-spin {
  width: 100%;
  margin: 40px 0 !important;
}
.ant-modal-close-x {
  height: 59px !important;
  line-height: 59px !important;
}
.ant-table-thead > tr > th {
  white-space: nowrap;
}
.ant-table td {
  white-space: nowrap;
}
.disable-with-white-color .ant-input-disabled {
  background-color: #fff;
  opacity: 1;
  cursor: default;
  color: rgba(0, 0, 0, 0.65);
  border: none;
}
.disable-with-white-color .ant-input-disabled + .ant-calendar-picker-icon {
  display: none;
}
.disable-with-white-color .ant-input-disabled .ant-calendar-picker-icon {
  display: none;
}
.disable-with-white-color .ant-input-disabled .ant-calendar-range-picker-input {
  cursor: default;
}
.disable-with-white-color .ant-input-disabled:hover {
  border: none;
}
.ant-cascader-menus .ant-cascader-menu {
  height: 300px;
  min-width: 180px;
}
.index__formSearchStyle____XxoS .ant-form-item {
  margin-bottom: 6px !important;
}
.index__formSearchStyle____XxoS .ant-form-item-control-wrapper {
  flex: 1;
}
.index__formSearchStyle____XxoS .ant-calendar-picker {
  width: 100% !important;
}
.index__formSearchStyle____XxoS .index__searchButtons___QwA1j {
  white-space: nowrap;
  margin-bottom: 24px;
  float: right;
  margin-right: 20px;
}
.index__formSearchStyle____XxoS .index__leftOperateButtons___lGAo1 {
  margin-bottom: 10px;
  display: block;
}
.index__formSearchStyle____XxoS .index__rightOperateButtons___lxDZ7 {
  white-space: nowrap;
  float: right;
  margin-right: 20px;
  margin-bottom: 10px;
}
.index__buttonSpace___h0EGJ {
  margin-right: 15px;
}
.index__modalOneColumn___hLMdY .ant-form-item {
  margin-bottom: 6px !important;
}
.index__modalTwoColumn___o8ydo {
  display: flex;
  padding-top: 10px;
}
.index__modalTwoColumn___o8ydo .ant-form-item {
  margin-bottom: 6px !important;
  display: flex;
}
.index__modalTwoColumn___o8ydo .ant-form-item-control-wrapper {
  flex: 1;
}
.index__modalTwoColumn___o8ydo .ant-calendar-picker {
  width: 100% !important;
}
.index__modalTwoColumn___o8ydo .ant-form {
  width: 360px;
}
.index__modalTwoColumnWithExtraContent___hi6F0 {
  display: flex;
  padding-top: 10px;
}
.index__modalTwoColumnWithExtraContent___hi6F0 .ant-form-item {
  margin-bottom: 6px !important;
  display: flex;
}
.index__modalTwoColumnWithExtraContent___hi6F0 .ant-form-item-control-wrapper {
  flex: 1;
}
.index__modalTwoColumnWithExtraContent___hi6F0 .ant-calendar-picker {
  width: 100% !important;
}
.index__modalTwoColumnWithExtraContent___hi6F0 .ant-form {
  width: 460px;
}
.index__formItemCenter___h7kNq .ant-form-item-label label {
  display: inline-flex;
  justify-content: center;
  align-items: center;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formSearchStyle": `index__formSearchStyle____XxoS`,
	"searchButtons": `index__searchButtons___QwA1j`,
	"leftOperateButtons": `index__leftOperateButtons___lGAo1`,
	"rightOperateButtons": `index__rightOperateButtons___lxDZ7`,
	"buttonSpace": `index__buttonSpace___h0EGJ`,
	"modalOneColumn": `index__modalOneColumn___hLMdY`,
	"modalTwoColumn": `index__modalTwoColumn___o8ydo`,
	"modalTwoColumnWithExtraContent": `index__modalTwoColumnWithExtraContent___hi6F0`,
	"formItemCenter": `index__formItemCenter___h7kNq`
};
export default ___CSS_LOADER_EXPORT___;
